var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_537_4204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.3333L9.99999 10L6.66666 13.3333",
    stroke: "#05ADAD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10V17.5",
    stroke: "#05ADAD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9917 15.3249C17.8044 14.8818 18.4465 14.1806 18.8166 13.3321C19.1866 12.4835 19.2635 11.5359 19.0352 10.6388C18.8068 9.7417 18.2862 8.94616 17.5556 8.37778C16.8249 7.80939 15.9257 7.50052 15 7.4999H13.95C13.6978 6.52427 13.2276 5.61852 12.575 4.85073C11.9223 4.08295 11.104 3.47311 10.1817 3.06708C9.25946 2.66104 8.25712 2.46937 7.25009 2.50647C6.24307 2.54358 5.25755 2.80849 4.36764 3.28129C3.47774 3.7541 2.70659 4.42249 2.11218 5.23622C1.51777 6.04996 1.11557 6.98785 0.935814 7.9794C0.756055 8.97095 0.803418 9.99035 1.07434 10.961C1.34527 11.9316 1.8327 12.8281 2.5 13.5832",
    stroke: "#05ADAD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.3333L9.99999 10L6.66666 13.3333",
    stroke: "#05ADAD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_537_4204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/uploadCloud.00a906a443421ee2d8c8f8bd5f6a317f.svg";
export { ForwardRef as ReactComponent };